import { Injectable } from '@angular/core';
import { DatasourceJobSettingsValidationService } from '@y42/datasource';
import { SqlModelingStoreModel } from '../../datasource/sql-modeling.model';

@Injectable({ providedIn: 'root' })
export class SqlModelingJobSettingsValidationService extends DatasourceJobSettingsValidationService<SqlModelingStoreModel> {}
